import React from 'react';

// STYLES
import { ContainerStyled } from './styles';

const Container: React.FC = (children: React.ReactNode) => {
  return <ContainerStyled>{children}</ContainerStyled>;
};

export default Container;
